import { inject, injectable } from 'inversify'
import { computed, makeObservable } from 'mobx'
import { Types } from '@core/ioc/types'
import type { WindowGateway } from '@core/services/window.gateway'
import { I18nRepository } from '@core/infra/i18n/i18n.repository'
import { VersionRepository } from './version.repository'

/**
 * Read side of the version check: what VersionBannerComponent renders, plus
 * the reload action its button fires. Polling and the version state itself
 * live in VersionRepository.
 */
@injectable()
export class VersionPresenter {
  @inject(VersionRepository)
  private versionRepository!: VersionRepository

  @inject(Types.IWindowGateway)
  private windowGateway!: WindowGateway

  @inject(I18nRepository)
  private i18nRepository!: I18nRepository

  constructor() {
    makeObservable(this, {
      viewModel: computed,
    })
  }

  get viewModel() {
    return {
      showVersionBanner: this.versionRepository.isUpdateAvailable,
      message: this.i18nRepository.t('connectivity.newVersion'),
      // No loading state here on purpose: this reloads the whole page (a new
      // build is available), not this Repository's own list.
      reloadLabel: this.i18nRepository.t('common.reload'),
    }
  }

  reload = () => {
    this.windowGateway.reload()
  }
}
